export const validateFonts = (
  payload: string | undefined,
): { error: string | null; isValid: boolean } => {
  if (!payload) return { error: null, isValid: true };
  let error: string | null = null;
  try {
    const parsed = JSON.parse(payload);
    const weights = [300, 400, 500, 600, 700, 900];
    if (!Array.isArray(parsed))
      return { error: "Invalid JSON format", isValid: false };
    if (parsed.length) {
      for (let i = 0; i < parsed.length; i++) {
        if (
          !parsed[i].hasOwnProperty("title") ||
          typeof parsed[i].title !== "string" ||
          !/^[A-Za-z\s]+$/.test(parsed[i].title) ||
          !parsed[i].hasOwnProperty("url") ||
          typeof parsed[i].url !== "string" ||
          !parsed[i].url.includes("https://") ||
          !parsed[i].hasOwnProperty("weight") ||
          typeof parsed[i].weight !== "number" ||
          (parsed[i].hasOwnProperty("type") &&
            !["serif", "sans-serif"].includes(parsed[i].type))
        ) {
          error =
            "Font object should have name (letters and spaces only), url, weight properties and optional type (serif or sans-serif)";
          return { error, isValid: false };
        }
      }

      const names = parsed.map((font) => font.title);
      if (new Set(names).size !== names.length) {
        error = "Font names should be unique";
        return { error, isValid: false };
      }

      for (let i = 0; i < parsed.length; i++) {
        if (!weights.includes(parsed[i].weight)) {
          error = "Font weight should be 300, 400, 500, 600, 700 or 900";
          return { error, isValid: false };
        }
      }
    }
  } catch (e) {
    error = "Invalid JSON format";
  }

  return { error, isValid: !error };
};
